/**
 * In android, files are served over the file protocol and to the actual path of files on the device
 * So only relative paths can be used to get to our files since they are some abitrary depth in the file system
 * The app is always on the index page and has hash paths that simulate deeper urls, so this isn't an issue
 * However the portal would prefer to avoid having to work out current path depth in order to use relative paths
 * So the plan for now is to use absolute paths on https: and relative paths on file
 * This could easily cause an issue somewhere in the future if developers aren't aware of this
 * But the alternative is too much work and to error prone to justify
 */
export function getPathPrefix() {
    if (document.location.protocol === 'file:') return ''
    return '/'
}
